import { Button, Modal } from '@payaca/ambrosia';
import { FunctionComponent, type JSX } from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirmDeleteScheduledEvent: () => void;
};

const ConfirmDeleteScheduledEventModal: FunctionComponent<Props> = ({
  isOpen,
  onClose,
  onConfirmDeleteScheduledEvent,
}: Props): JSX.Element | null => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete event">
      <Modal.Body>
        <p style={{ textAlign: 'center' }}>
          Are you sure you want to delete this event?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button onClick={onConfirmDeleteScheduledEvent}>Delete</Button>
          <Button variant="link" onClick={onClose}>
            Cancel
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteScheduledEventModal;
